import React from "react";
import "styles/pay/payments.css";
import PropTypes from "prop-types";
import PaymentButton from "./PaymentButton";
import { LogPaymentEvent } from "utils/logger";
import { usePaymentGateway } from "hooks/usePaymentGateway";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";

const Selectgateway = ({ setFormConfig, user, setUser }) => {
  const {
    loading,

    handlePayu,
  } = usePaymentGateway(user, setUser, setFormConfig);

  const handlePayColombia = () => {
    setFormConfig({ step: 5 });
  };

  return (
    <div className="payment-gateway-container">
      <button
        className="btn-back-step"
        onClick={() => {
          LogPaymentEvent("NAVIGATION", "back_step");
          setFormConfig({ step: 3 });
        }}
      >
        <ArrowIcon />
        Regresar
      </button>

      <section className="container-payments">
        <PaymentButton
          onClick={handlePayu}
          loading={loading.payu}
          icon="https://www.svgrepo.com/show/408253/world-map.svg"
          className="international"
          data-testid="payu-button"
        >
          Pagar desde el exterior
        </PaymentButton>

        <PaymentButton
          onClick={handlePayColombia}
          icon="https://www.svgrepo.com/show/405455/flag-for-flag-colombia.svg"
          className="national"
        >
          Pagar desde Colombia
        </PaymentButton>
      </section>
    </div>
  );
};

Selectgateway.propTypes = {
  setFormConfig: PropTypes.func.isRequired,
  user: PropTypes.shape({
    contrato: PropTypes.string.isRequired,
    titular: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    monto: PropTypes.number.isRequired,
    codigo: PropTypes.string.isRequired,
    tipo: PropTypes.string.isRequired,
    url_payU: PropTypes.string,
  }).isRequired,
  setUser: PropTypes.func.isRequired,
};

export default Selectgateway;
